import { render, staticRenderFns } from "./ScrollToNewIcon.vue?vue&type=template&id=4c35244e&"
import script from "./ScrollToNewIcon.vue?vue&type=script&lang=js&"
export * from "./ScrollToNewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports